import {PeppinMain, PeppinMainProps, PeppinMainState} from "./app-shared/common/PeppinApp";
import React, {createRef} from "react";
import {PathComponent} from "../index";
import {Outlet} from "react-router-dom";
import {HomeFragment} from "./HomeFragment";
import {LoginFragment} from "../shared/LoginFragment";
import {ViewProfileFragment} from "./ViewProfileFragment";
import {FooterBar, HeaderBar, HeaderLink} from "./app-shared/common/Components";
import {Action} from "../shared/types";
import {AddOutlined, ExitToAppOutlined, MessageOutlined, NotificationsOutlined} from "@mui/icons-material";
import {TrendingFragment} from "./TrendingFragment";
import {FollowingFragment} from "./FollowingFragment";
import {ComposerHelper} from "./profile/ComposerHelper";
import {SettingsFragment} from "./SettingsFragment";
import {RedirectProfileFragment} from "./RedirectProfileFragment";
import {MessagesFragment} from "./messages/MessagesFragment";
import {NotificationsFragment} from "./notifications/NotificationsFragment";
import {App} from "./App";

export class Main extends PeppinMain {

  static nestedPaths(): PathComponent[] {
    return [
      {
        path: "home",
        render: pathProps => <HomeFragment path={pathProps}/>,
      },
      {
        path: "following",
        render: pathProps => <FollowingFragment path={pathProps}/>,
      },
      {
        path: "trending",
        render: pathProps => <TrendingFragment path={pathProps}/>,
      },
      {
        path: "profile",
        render: pathProps => <RedirectProfileFragment path={pathProps}/>,
      },
      {
        path: "messages",
        render: pathProps => <MessagesFragment path={pathProps}/>,
      },
      {
        path: "notifications",
        render: pathProps => <NotificationsFragment path={pathProps}/>,
      },
      {
        path: "login",
        render: pathProps => <LoginFragment path={pathProps}/>,
      },
      {
        path: "settings",
        children: SettingsFragment.nestedPaths(),
        render: pathProps => <SettingsFragment path={pathProps}/>,
      },
      {
        path: ":username",
        children: ViewProfileFragment.nestedPaths(),
        render: pathProps => <ViewProfileFragment path={pathProps}/>,
      },
    ];
  }

  private readonly scrollContainer = createRef<HTMLDivElement>();

  componentDidUpdate(prevProps: Readonly<PeppinMainProps>, prevState: Readonly<PeppinMainState>, snapshot?: any) {
    super.componentDidUpdate(prevProps, prevState, snapshot);
    if (prevProps.path.location.pathname !== this.props.path.location.pathname) {
      setTimeout(() => this.scrollContainer.current?.scrollTo({left: 0, top: 0, behavior: "smooth"}), 1);
    }
  }

  renderContainerContent(): React.ReactElement {
    return this.renderContent();
  }

  private readonly userActions: Action[] = [
    new Action("View profile", () => {
      App.CONTEXT.hideDialog();
      this.props.path.navigate("/profile");
    }, ExitToAppOutlined),
  ];

  renderContent(): React.ReactElement {
    const path = this.props.path.location.pathname?.trim();
    let n = path.length;
    while (path[--n] === "/") {
      // Continue
    }
    let showHeaderBar = true;
    if (path === "/login") {
      showHeaderBar = false;
    }
    const links: HeaderLink[] = [
      {
        text: "Home",
        url: "/home",
      },
      {
        text: "Trending",
        url: "/trending",
      },
    ];

    const actions: Action[] = [];
    if (Boolean(this.memberAuth?.auth?.currentUser)) {
      links.push(...[
        {
          text: "Following",
          url: "/following",
        },
      ]);
    }
    if (Boolean(this.memberAuth?.auth?.currentUser)) {
      actions.push(...[
        new Action("Messages", () => this.props.path.navigate("/messages"), MessageOutlined).setDisplay("icon"),
        new Action("Notifications", () => this.props.path.navigate("/notifications"), NotificationsOutlined).setDisplay("icon"),
        new Action("Add New", () => ComposerHelper.addItem(this.props.path), AddOutlined),
      ]);
    }
    return <div style={{display: "flex", flexDirection: "column", flexGrow: 1, overflow: "hidden"}}>
      {showHeaderBar
        ? <HeaderBar
          links={links}
          actions={actions}
          userActions={this.userActions}
          path={this.props.path}
          showLoginButton
          style={{background: "white"}}/>
        : null}
      <div ref={this.scrollContainer}
           style={{display: "flex", flexDirection: "column", flexGrow: 1, overflowY: "scroll"}}>
        <Outlet/>
        <FooterBar
          path={this.props.path}
          style={{}}/>
      </div>
    </div>;
  }
}